import {
  appVersion,
  name,
  numbers,
  specialChars,
  description,
  appLogoTopUrl,
  appLogoBottomUrl,
  showFooterEULogotypes
} from './base.config';

export const environment = {
  appVersion,
  specialChars,
  numbers,
  name,
  description,
  appLogoTopUrl,
  appLogoBottomUrl,
  showFooterEULogotypes,
  production: false,
  apiDomain: 'https://um-wronki.test.aspello.pl',
  apiBasePath: 'https://um-wronki.test.aspello.pl/system/api/v1',
  localEnv: true,
  ssl: false
};
